import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getAuditoriaPeriodo(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("filasAtendimento/access/gerarAuditoriaPeriodo", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getFilaExamesPeriodo(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("filasAtendimento/access/listarExames", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getFilaExamesComplementos(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("filasAtendimento/access/listarExamesComplementos", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    postFilaExamesHorario(context, dados) {
        return new Promise(resolve => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("filasAtendimento/access/salvarHoraExame", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    postFilaExamesComplemento(context, dados) {
        return new Promise(resolve => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("filasAtendimento/access/salvarExameComplemento", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};